<template>
<v-list-item 
    v-if="can_access_route"
    
    :to="linkedRoute?.path" 
    :prepend-icon="'mdi-' + linkedRoute?.meta?.icon"
    :title="linkedRoute?.meta?.title"

>
<template v-slot:append>
</template>
</v-list-item>
</template>

<script setup>

import { onMounted, ref } from 'vue'
import { useRuntimeStore } from "@/store/runtime"
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import { checkAuth } from "@/router/guard/index.js"


const runtimeStore = useRuntimeStore();

const props = defineProps(["routeName"])

const router = useRouter();

const linkedRoute = ref(null)
const can_access_route = ref(false)

const route = useRoute()


onMounted(() => {
    // getRoute(props.routeName)
    linkedRoute.value =  router.resolve({ name: props.routeName });
    
    can_access_route.value = checkAuth(linkedRoute.value?.meta?.auth)
    if (!can_access_route.value) {
        console.log("Cannot access route: ")
        console.log(linkedRoute.value?.name)
        console.log(linkedRoute.value?.path)
        console.log(linkedRoute.value?.meta?.auth)
    }

})


</script>

<style scoped>
.v-list-item.isActive {
  color: #64B5F6;
}
</style>
